
import { Component, Vue, Prop } from "nuxt-property-decorator";

@Component
export default class TheDetails extends Vue {
  @Prop() item!: any;
}
